<template>
  <div class="back">
    <div class="center" align="center">
      <h1 style="color:  #2e5c9a;text-align: center">合作伙伴黑名单曝光台</h1>
      <div style="margin-top: 2%;width: 90%;text-align: left;margin-left: 5%;">
        <p style="text-align: left;margin-left:0%;padding-top: 2%;
        width: 90%;background-color: #409EFF;color:white;border-radius: 5px;
        padding-top: 6px;padding-bottom: 6px;padding-left: 3%"><b>快捷查询</b></p>
        <el-form  ref="form" :rules="rules" :model="form" label-width="80px" label-position="left" inline >
          <el-form-item label="企业名称" prop="name">
            <el-input
              type="text"
              placeholder="企业名称"
              class="ptTxtInput"
              style="width: 250px"
              size="small"
              v-model="form.name">
            </el-input>
          </el-form-item>
          <el-form-item label="统一社会信息代码" prop="idCard" label-width="150px" style="margin-top: -7%">
            <el-input
              type="text"
              placeholder="统一社会信息代码"
              class="ptTxtInput"
              style="width: 330px;position: relative;top: -8px"
              size="small"
              v-model="form.idCard">
            </el-input>
          </el-form-item>
          <el-button type="primary" size="mini" plain style="width:26%;
          text-align: center;margin-left: 36%;font-size: 14px;position: relative;top: -20px " @click="handleSearch" >查 询</el-button>

        </el-form>
        <div v-if="isShow" style="text-align: left;margin-top: -1.5%;font-size: 14px;width: 98%">
          <span>查询结果：</span><span style="color: red">{{msg}}</span>
        </div>
      </div>
    </div>
    <div style="position:fixed;top: 350px;height: 50px;width: 90%;margin-left: 5%;background-color: white;z-index: 99">
      <p style="text-align: left;margin-left:3%;padding-top: 2%;
        width: 90%;background-color: #409EFF;color:white;border-radius: 5px;
        padding-top: 6px;padding-bottom: 6px;padding-left: 3%"><b>公示名单</b>
        <span style="font-size: 11px;margin-left: 2%">(企业信息来源：国家企业信用信息公示系统)</span></p>
    </div>
    <div class="table" style="width: 84%;margin-left: 7.7%;position: relative;top: 400px;">
      <div v-for="(item,index) in tableData" style="border: 1px solid #409EFF;margin-top: 20px;text-align: left;border-radius: 5px">
        <div style="margin-left: 5%;font-size: 14px;line-height: 10px">
          <p>序号：{{item.seq}}</p>
          <p>企业名称：{{item.name}}</p>
          <p>统一社会信息代码：{{item.idCard}}</p>
          <p>除名日期：{{item.dismissTime}}</p>
        </div>
      </div>
      <div style="height: 30px">
        &ensp;
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/api/request'
export default {
  name: "board",
  data(){
    return{
      form:{
        name:"",
        idCard:""
      },
      resShow:false,
      isShow:false,
      rules: {
        // name: [
        //   { required: true, message: '请输入企业名称', trigger: 'blur' },
        // ],
        // idCard: [
        //   { required: true, message: '请输入统一社会信息代码', trigger: 'blur' },
        // ],
      },
      tableData: [],
      msg:""
    }
  },
  created() {
    this.getDataList();
  },
  methods:{
    //获取数据
    getDataList(){
      let httpURL = `/blacklist/show_list`; //目标地址后接的详细地址
      let formData = new FormData();
      formData.append('pageSize', 200);
      formData.append('pageNum', 1);
      let that=this;
      request.post(httpURL,formData).then(function (res) {
        // console.log(res);
        if (res.code == "0") {
          // console.log(res);
          // that.tableData=res.rows;
          let resData=res.rows;
          for(let i=0;i<resData.length;i++){
            resData[i].dismissTime=(resData[i].dismissTime).substring(0,10);
            resData[i].seq=i+1;
          }
          that.tableData=resData;
          that.total=res.total;
        }
      })
    },
    handleSearch(){
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let httpURL = `/blacklist/find_supplier`; //目标地址后接的详细地址
          let data=this.form;
          let that=this;
          // this.isShow=true;
          request.post(httpURL, data).then(function (res) {
            // console.log(res);
            if (res.code == "0") {

              that.isShow=true;
              that.msg=res.msg;
            }
          })

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>
body{

}
.back{
  position : absolute;
  top:0;
  left: 0;
  width : 100%;
  height :100%;
  /*background-image: url("../png/boardback.jpg");*/
  /*background-size:100% 100%;*/
}
.center{
  position: fixed;
  background-color: white;
  top: 0;
  left: 0;
  height: 355px;
  z-index: 99;
}
.search_title{
  font-size: 16px;
}
.search_input{
  width: 60%;
  border: 0px;
  line-height: 30px;
  color: skyblue;
  font-size: 18px;
  border-bottom: 2px solid seashell;
  background-color: inherit;
}

.search_button{
  margin-top: 30px;
  height: 40px;
  width: 60%;
  border-radius: 60px;
  /*background-color: white;*/
  background-image: linear-gradient(to bottom right, deepskyblue, skyblue);
  overflow: hidden;
  border:1px solid #2e5c9a;
  color:white;
  font-size: 17px;
}

.result{
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/pages/pc/supplierBoard.vue